/* eslint-disable react/jsx-props-no-spreading */
import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import ConfigRow from '../../../../components/ConfigRow/ConfigRow';
import configMobileStore from '../../stores';
import { IConfigMobileConfiguration, IConfigMobileFirebaseRow, IConfigMobileFirebaseWebRow, TConfigMobileFirebaseValidationKey } from '../../types';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { IValidation } from 'src/types/main';
import './style.scss';

const MobileConfigConfigurationTab: FC = observer((): JSX.Element => {
  const changeFirebase = (field: keyof IConfigMobileConfiguration['firebase']) => (value: string | undefined) => {
    configMobileStore.changeConfigFirebase({ [field]: value });
  };

  const changeFirebaseWeb = (field: keyof IConfigMobileConfiguration['firebaseWeb']) => (value: string | undefined) => {
    configMobileStore.changeConfigFirebaseWeb({ [field]: value });
  };

  const rowProps = {
    enableTypeSwitch: true,
    className: 'mobile-config-row',
    titleClassName: 'mobile-config-row__title',
    inputClassName: 'mobile-config-row__input',
  };

  const firebaseRows = useMemo(
    (): IConfigMobileFirebaseRow[] => [
      { field: 'apiKey', title: 'firebase_api_key', required: true, validation: true },
      { field: 'projectId', title: 'firebase_project_id', required: true, validation: true },
      { field: 'appStaffApiKey', title: 'app_staff_firebase_api_key', required: true, validation: true },
      { field: 'appStaffProjectId', title: 'app_staff_firebase_project_id', required: true, validation: true },
      { field: 'secondApiKey', title: 'firebase_second_api_key' },
      { field: 'secondProjectId', title: 'firebase_second_project_id' },
    ],
    []
  );

  const firebaseWebRows = useMemo(
    (): IConfigMobileFirebaseWebRow[] => [
      { field: 'apiKey', title: 'web_api_key' },
      { field: 'authDomain', title: 'web_auth_domain' },
      { field: 'projectId', title: 'web_project_id' },
      { field: 'storageBucket', title: 'web_storage_bucket' },
      { field: 'messagingSenderId', title: 'web_messaging_sender_id' },
      { field: 'appId', title: 'web_app_id' },
      { field: 'measurementId', title: 'web_measurement_id' },
    ],
    []
  );

  return (
    <div className="d-flex flex-column mt-4">
      <Text type={TEXT.SECTION_HEADER} text="firebase_settings" />
      <div className="d-flex flex-column mt-4 gap-15">
        {firebaseRows.map((row) => (
          <ConfigRow
            key={row.field}
            title={row.title}
            value={configMobileStore.configuration.firebase[row.field]}
            onChange={changeFirebase(row.field)}
            required={row.required}
            masked
            validation={
              row.validation ? (configMobileStore.firebaseValidation[row.field as TConfigMobileFirebaseValidationKey] as IValidation) : undefined
            }
            {...rowProps}
          />
        ))}
      </div>

      <Text type={TEXT.SECTION_HEADER} text="firebase_web_settings" className="mt-6" />
      <div className="d-flex flex-column mt-4 gap-15">
        {firebaseWebRows.map((row) => (
          <ConfigRow
            key={row.field}
            title={row.title}
            masked
            value={configMobileStore.configuration.firebaseWeb[row.field]}
            onChange={changeFirebaseWeb(row.field)}
            {...rowProps}
          />
        ))}
      </div>
    </div>
  );
});

export default MobileConfigConfigurationTab;
